const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
    employees: [],
    employee: null,
    loading: false,
    error: null,
};

const employeesSlice = createSlice({
    name: "employees",
    initialState,
    reducers: {
        setEmployeesState: (state, { payload }) => {
            state.employees = payload;
        },
        setEmployeeState: (state, { payload }) => {
            state.employee = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },

});

export const { setEmployeesState, setEmployeeState, setLoading, setError } =
    employeesSlice.actions;

export default employeesSlice.reducer;
